import { Badge, Button, Checkbox, Input, Popover, Select, Tabs, TimePicker } from 'antd';
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap';
import AppContext from '../../../Context/AppContext';
import { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faMinusCircle, faPen, faPlusCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { RoleUserPicker } from '../../Roles/RoleUserPicker';
import TextArea from 'antd/es/input/TextArea';
import ReminderSvg from '../../../assets/images/svg/AlarmReminderBlack.svg';
import dayjs from 'dayjs';
import './TaskFlowReminder.css'
import moment from 'moment';
import GlobalRecurring from '../../Reccuring/GlobalRecurring';
import AwsServerService from '../../../common/util/AwsServerService';
import { useDispatch, useSelector } from 'react-redux';
import HierarchicalDropdown from '../../Roles/HierarchicalDropdown';
// import ReminderSvg from '../../src/assets/images/svg/AlarmReminderBlack.svg';

export const TaskFlowReminder = ({ onAddReminder, setReminders, reminders }) => {
    const AppData = useContext(AppContext);
    const { dispatch, state } = AppData || {};

    const reduxDispatch = useDispatch(); // Dispatch actions

    const weekdays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    const [error, setError] = useState([]);
    const [tab, setTab] = useState("1");
    const [searchValue1, setSearchValue1] = useState("");
    const validationFields = [
        "Status", "ReminderType", "TriggerType",
    ]
    let defaultReminder = {
        Status: "",
        ReminderType: "",
        TriggerType: "OSE",
        TriggerTime: {
            D: 0,
            H: 0,
        },
        Attendees: [{
            Attendee:"",
            AttendeeType:"",
        }],
        IsRecurring: 0,
        Recursion: {
            OnDay: new Date().getDate(),
            OnMonth: "OnDay",
            EventDate: new Date(Date.now()),
            MonthStep: "1",
            MonthDay: weekdays[new Date().getDay()],
            Time: new Date(),
            DailyIntervalCount: "1",
            WhichMonth: `${new Date().getMonth() + 1}`,
            EndBy: "Never",
            Repeat: "Daily",
            DailyInterval: "Every",
            WeeklyDay: `${dayjs().format("dddd")}`,
        },
    }
    const [openReminder, setOpenReminder] = useState(false);
    const [reminderContent, setReminderContent] = useState({
        Status: [],
        ReminderType: "",
        TriggerType: "OSE",
        TriggerTime: {
            D: 0,
            H: 0,
        },
        IsRecurring: 0,
        Attendees: [{
            Attendee:"",
            AttendeeType:"",
        }],
        // AttendeesType:[],
        Recursion: {
            OnDay: new Date().getDate(),
            OnMonth: "OnDay",
            EventDate: new Date(Date.now()),
            MonthStep: "1",
            MonthDay: weekdays[new Date().getDay()],
            Time: new Date(),
            DailyIntervalCount: "1",
            WhichMonth: `${new Date().getMonth() + 1}`,
            EndBy: "Never",
            Repeat: "Daily",
            DailyInterval: "Every",
            WeeklyDay: `${dayjs().format("dddd")}`,
        },
    });


    const [eventData, setEventData] = useState({
        color: "#8cbf40",
        action: [
            {
                NotificationBy: ["email"],
                NotificationOn: "before",
                NotificationTime: "5",
            },
        ],
    });
   
    let repeatEventObject = {
        OnDay: new Date().getDate(),
        OnMonth: "OnDay",
        EventDate: new Date(Date.now()),
        MonthStep: "1",
        MonthDay: weekdays[new Date().getDay()],
        DailyIntervalCount: "1",
        WhichMonth: `${new Date().getMonth() + 1}`,
        HourlyInterval:"00:00",
        EndBy: "Never",
        Repeat: "Daily",
        DailyInterval: "Every",
        WeeklyDay: `${dayjs().format("dddd")}`,
    }

    const [repeatObj, setRepeatObj] = useState({ ...repeatEventObject });
    const [refreshRecurringData, setRefreshRecurringData] = useState(0);
    const [fromDate, setFromDate] = useState(null);
    const [tillDate, setTillDate] = useState(null);
    const [action, setAction] = useState("create");

    useEffect(e => {
        console.log(repeatObj);
    }, [repeatObj])

    const onChangeField = ({ value, field, data, setDataFunction, isSetKey }) => {
         
        if (isSetKey) {
            data[isSetKey] = data[isSetKey] || {};
            if (field) {
                data[isSetKey][field] = value;
            }
        } else {
            if (field) {
                data[field] = value;
            }
        }
        setDataFunction && setDataFunction(data);
    }
    const onReminderSave = () => {
        let arr = [];
        validationFields.forEach(key => {
            if (reminderContent[key] != "" && reminderContent[key] != undefined && reminderContent[key] != null) {
            } else {
                if (!arr.includes(key)) {
                    arr.push(key)
                }
            }
        });
        if (arr.length > 0) {
            // alert("Require fields")
            setError(arr);
            return;
        } else {
            // AwsServerService.CrudServiceHandler({ method: "POST", data:{...reminderContent}, route: "TASKFLOWREMINDER" }).then(res => {
            //     setReminderContent(defaultReminder)
            //     setOpenReminder(false);
            // }).catch(err => {
            //     console.log(err);
            // })
            let d = { ...reminderContent };
            let arr = [...reminders];
            if (d.ROWID) {
                arr = arr.filter(r => r.ROWID != d.ROWID);
                d["ROWID"] = dayjs(new Date()).format('YYYYMMDDHHmmssSSS');
            } else {
                d["ROWID"] = dayjs(new Date()).format('YYYYMMDDHHmmssSSS');;
            }
            arr.push(d);
            setReminderContent(defaultReminder)
            setTab("1");
            // setOpenReminder(false);
            setReminders(arr);
        }
    }
    const deleteReminder = (rem) => {
        if (rem.ROWID) {
            let arr = reminders.filter(k => k.ROWID != rem.ROWID);
            setReminders(arr);
        }
    }
    const onClickReminder = (rem) => {
        let {
            ROWID,
            Status,
            ReminderType,
            TriggerType,
            TriggerTime,
            Attendees,
            IsRecurring,
            Recursion,
        } = rem;
        setReminderContent({
            ROWID: ROWID,
            Status: Status,
            ReminderType: ReminderType,
            TriggerType: TriggerType,
            TriggerTime: TriggerTime || {
                D: 0,
                H: 0,
            },
            Attendees: Attendees || [],
            IsRecurring: IsRecurring,
            Recursion: Recursion,
        })
        setTab("2");
    }
    const onChnageRoleUserType=({value,index,name})=>{
        let d = {...reminderContent}
        d.Attendees = d.Attendees.map((data,i)=>{
            if(i==index){
                if(name == "Attendee"){
                    data[name] = value;
                    // data["AttendeeType"] = value.split("_")[0];
                }else{
                    data[name] = value;
                }
            }
            return data;
        })
        setReminderContent(d);
    }
    return (
        <Popover
            overlayClassName='BluePrint-Reminder'
            open={openReminder}
            destroyTooltipOnHide
            onOpenChange={e => {
                setError([])
                setReminderContent(defaultReminder);
                setOpenReminder(e)
            }}
            content={<div>
                <Tabs activeKey={tab} defaultActiveKey={'1'} onChange={t => {
                    setTab(t)
                }}>
                    <Tabs.TabPane tab={"Reminder List"} key={"1"}>
                        {reminders?.map(rem => {
                            return <div className='Task-Reminder-Card'
                            >
                                <img style={{ width: "16px" }} src={ReminderSvg} />
                                <span onClick={e => onClickReminder(rem)}>{state?.FlowEdgeAndNodes?.nodes?.find(ed => ed.id == rem.Status)?.data?.label}</span>
                                <div style={{ display: "flex", position: "absolute", right: "0px", gap: "5px" , cursor : "pointer"}}>
                                    <FontAwesomeIcon onClick={e => onClickReminder(rem)} color='#5b6c97' icon={faPen} />
                                    <FontAwesomeIcon onClick={e => deleteReminder(rem)} color='red' icon={faTrashAlt} />
                                </div>
                            </div>
                        })}
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={"Create Reminder"} key={"2"}>
                        <div className="Custom-Input-Wrapper">
                            <div className='Reminder-B-Component'>
                                <Row className="Input-Group mb-3 mt-2">
                                    <Col>
                                        <span className="labeltext">
                                            Select Reminder Type <span style={{ color: "red" }}>*</span>
                                        </span>
                                        <Select
                                            mode="multiple"
                                            value={reminderContent.ReminderType ? reminderContent.ReminderType?.split(",") : null}
                                            style={{ width: "100%", height: "auto" }}
                                            className={`${error.includes("ReminderType") && "InvalidFieldCss"}`}
                                            onBlur={e => {
                                                let key = "ReminderType";
                                                if (reminderContent[key] != "" && reminderContent[key] != undefined && reminderContent[key] != null) {
                                                    setError(prev => prev.filter(k => k != key))
                                                } else {
                                                    setError(prev => {
                                                        let arr = [...prev]
                                                        if (!prev.includes(key)) {
                                                            arr.push(key)
                                                        }
                                                        
                                                        return arr;
                                                    })
                                                }
                                            }}
                                            onChange={(val) => {
                                                let key = val;
                                                if (key != "" && key != undefined && key != null) {
                                                    setError(prev => prev.filter(k => k != "ReminderType"))
                                                }
                                                onChangeField({
                                                    value: val.join(","),
                                                    field: "ReminderType",
                                                    data: { ...reminderContent },
                                                    setDataFunction: (d) => setReminderContent(d),
                                                    // isSetKey:"data"
                                                })
                                            }}
                                        >
                                            <Select.Option key={"Email"} >Email</Select.Option>
                                            <Select.Option key={"Popup"} >Popup</Select.Option>
                                            <Select.Option key={"Notification"} >Notification</Select.Option>
                                        </Select>
                                    </Col>
                                </Row>
                                <Row className="Input-Group mb-3">
                                    <Col>
                                        <span className="labeltext">
                                            Select Status <span style={{ color: "red" }}>*</span>
                                        </span>
                                        <Select
                                            mode=""
                                            searchValue={searchValue1}
                                            style={{ width: "100%", height: "auto" }}
                                            filterOption={(input, option) =>
                                                {
                                                     
                                                    return option.searchText.toLowerCase().includes(searchValue1?.toLowerCase())
                                                }
                                            }
                                            value={reminderContent.Status}
                                            className={`${error.includes("Status") && "InvalidFieldCss"}`}
                                            dropdownRender={(menu) => (
                                                <div>
                                                    {/* Static search box that controls Select's search */}
                                                    <Input
                                                        placeholder="Search..."
                                                        value={searchValue1}
                                                        onChange={(e) => setSearchValue1(e.target.value)}
                                                        autoFocus
                                                        style={{ marginBottom: 8, width: "100%" }}
                                                    />
                                                    {menu}
                                                </div>)}
                                            onBlur={e => {
                                                let key = "Status";
                                                if (reminderContent[key] != "" && reminderContent[key] != undefined && reminderContent[key] != null) {
                                                    setError(prev => prev.filter(k => k != key))
                                                } else {
                                                    setError(prev => {
                                                        let arr = [...prev]
                                                        if (!prev.includes(key)) {
                                                            arr.push(key)
                                                        }
                                                        return arr;
                                                    })
                                                }
                                            }}
                                            onChange={val => {
                                                let key = val;
                                                if (key != "" && key != undefined && key != null) {
                                                    setError(prev => prev.filter(k => k != "Status"))
                                                }
                                                onChangeField({
                                                    value: val,
                                                    field: "Status",
                                                    data: { ...reminderContent },
                                                    setDataFunction: (d) => setReminderContent(d),
                                                    // isSetKey:"data"
                                                })
                                            }}
                                        >
                                            {state?.FlowEdgeAndNodes?.nodes?.map(ed => {
                                                if (ed.type == "diverse") {
                                                    return <></>
                                                }
                                                return <Select.Option searchText={ed.data?.label} key={ed.id} >
                                                    <span
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    ><FontAwesomeIcon className="mr-2" icon={faCircle} color={ed?.data?.color ? ed?.data?.color : "grey"} />{ed.data?.label}</span>
                                                </Select.Option>
                                            })}
                                        </Select>
                                    </Col>
                                </Row>
                                <div style={{
                                    borderLeft: "5px solid #e3e3e3",
                                    paddingLeft: "8px"
                                }} >
                                    {reminderContent?.Attendees.map((r, i) => {
                                        return <Row className="Input-Group mb-3">
                                            <Col sm={3}>
                                                <span className="labeltext">
                                                    Assignee Type <span style={{ color: "red" }}>*</span>
                                                </span>
                                                <Select
                                                    placeholder={"Select User Type"}
                                                    style={{ width: "100%", height: "auto" }}
                                                    value={reminderContent.Attendees[i].AttendeeType}
                                                    onChange={(value, option) => {
                                                        //  
                                                        // onChangeField({
                                                        //     value: value,
                                                        //     field: "Attendee",
                                                        //     data: { ...reminderContent },
                                                        //     setDataFunction: (d) => setReminderContent(d),
                                                        //     isSetKey:"Attendees"
                                                        // })
                                                        onChnageRoleUserType({ value: value, name: "AttendeeType", index: i })
                                                    }}
                                                // mode='multiple'
                                                >
                                                    <Select.Option value={"Role"} >Role</Select.Option>
                                                    <Select.Option value={"Account"} >Account</Select.Option>
                                                    <Select.Option value={"Vendor"} >Vendor</Select.Option>
                                                    <Select.Option value={"Zoho"} >Zoho</Select.Option>
                                                </Select>
                                            </Col>
                                            <Col sm={7}>
                                                <span className="labeltext">
                                                    {`Select ${reminderContent.Attendees[i].AttendeeType?reminderContent.Attendees[i].AttendeeType:"Roles"}`} <span style={{ color: "red" }}>*</span>
                                                </span>
                                               
                                                
                                                <HierarchicalDropdown
                                                    disabledCondition={!reminderContent.Attendees[i].AttendeeType}
                                                    key={"rolepicker"+i}
                                                    GroupName={["Account","Zoho","Vendor","Role"].filter(t=>t==reminderContent.Attendees[i].AttendeeType)}
                                                    handleChangeUser={(value, option) => {
                                                         
                                                        onChnageRoleUserType({value:value,name:"Attendee",index:i})
                                                    }}
                                                    selectedUsers={reminderContent.Attendees[i].Attendee}
                                                />
                                            </Col>
                                            
                                            <Col className='d-flex align-items-center p0m0' sm={2}>
                                                {i==0 &&
                                                <FontAwesomeIcon
                                                    className='mr-2'
                                                    onClick={e => {
                                                        if (reminderContent.Attendees[i].AttendeeType && reminderContent.Attendees[i].Attendee) {
                                                            setReminderContent(prev => {
                                                                let d = { ...prev }
                                                                d.Attendees.unshift({
                                                                    Attendee: "",
                                                                    AttendeeType: "",
                                                                })
                                                                return d;
                                                            })
                                                        }
                                                    }}
                                                    color={reminderContent.Attendees[i].AttendeeType && reminderContent.Attendees[i].Attendee? 'green':"gray"} icon={faPlusCircle} />
                                                }
                                                <FontAwesomeIcon
                                                    
                                                    onClick={e => {
                                                        setReminderContent(prev => {
                                                            let d = { ...prev }
                                                            if(d.Attendees.length!=1){
                                                                d.Attendees = d.Attendees.filter((d, k) => k != i);
                                                            } else{
                                                                d.Attendees = [{
                                                                    Attendee:"",
                                                                    AttendeeType:"",
                                                                }]
                                                            }
                                                            return d;
                                                        })
                                                    }}
                                                    color='red' icon={faMinusCircle} />
                                            </Col>
                                        </Row>
                                    })}
                                </div>
                                <Row className="Input-Group mb-3">
                                    <Col>
                                        <span className="labeltext">
                                            Select Trigger <span style={{ color: "red" }}>*</span>
                                        </span>
                                        <Select
                                            // mode="multiple"
                                            style={{ width: "100%", height: "auto" }}
                                            value={reminderContent.TriggerType}
                                            className={`${error.includes("TriggerType") && "InvalidFieldCss"}`}
                                            onBlur={e => {
                                                let key = "TriggerType";
                                                if (reminderContent[key] != "" && reminderContent[key] != undefined && reminderContent[key] != null) {
                                                    setError(prev => prev.filter(k => k != key))
                                                } else {
                                                    setError(prev => {
                                                        let arr = [...prev]
                                                        if (!prev.includes(key)) {
                                                            arr.push(key)
                                                        }
                                                        return arr;
                                                    })
                                                }
                                            }}
                                            onChange={val => {
                                                let key = val;
                                                if (key != "" && key != undefined && key != null) {
                                                    setError(prev => prev.filter(k => k != "TriggerType"))
                                                }
                                                onChangeField({
                                                    value: val,
                                                    field: "TriggerType",
                                                    data: { ...reminderContent },
                                                    setDataFunction: (d) => setReminderContent(d),
                                                    // isSetKey:"data"
                                                })
                                            }}
                                        >
                                            <Select.Option key={"OSE"} >On Status Entry</Select.Option>
                                            <Select.Option key={"OSC"} >On Status Completion</Select.Option>
                                            <Select.Option key={"LT"} >Longer Than</Select.Option>
                                        </Select>
                                    </Col>
                                    {!["OSE","OSC"].includes(reminderContent.TriggerType) && <><Col sm={3}>
                                        <span className="labeltext">
                                            Days
                                        </span>
                                        <Input

                                            value={reminderContent?.TriggerTime?.D}
                                            onChange={val => {
                                                onChangeField({
                                                    value: val.currentTarget.value,
                                                    isSetKey: "TriggerTime",
                                                    field: "D",
                                                    data: { ...reminderContent },
                                                    setDataFunction: (d) => setReminderContent((prev) => {
                                                        return d;
                                                    }),
                                                })
                                            }}
                                        >
                                        </Input>
                                    </Col>
                                    <Col sm={3}>
                                        <span className="labeltext">
                                            Hour's
                                        </span>
                                        <TimePicker
                                            format={"HH:mm"}
                                            // placeholder=''
                                            value={dayjs(reminderContent?.TriggerTime?.H || "00:01","HH:mm")}
                                            onChange={val => {
                                                onChangeField({
                                                    value: dayjs(val?.$d).format("HH:mm"),
                                                    isSetKey: "TriggerTime",
                                                    field: "H",
                                                    data: { ...reminderContent },
                                                    setDataFunction: (d) => setReminderContent((prev) => {
                                                        //  
                                                        // let minutes = 0;
                                                        // let Day = d.TriggerTime["D"]?.$d ? moment(d.TriggerTime["D"]?.$d).minutes() : 0;
                                                        // let Hours = d.TriggerTime["T"]?.$d ? moment(d.TriggerTime["T"]?.$d).hours() : 0;
                                                        // let Mins = d.TriggerTime["T"]?.$d ? moment(d.TriggerTime["T"]?.$d).minutes() : 0;
                                                        // // minutes = minutes + moment(d.time["T"]?.$d, "HH:mm").hours() * 60 + ;
                                                        // if (Day > 0) {
                                                        //     minutes = minutes + Day * 24 * 60;
                                                        // }
                                                        // if (Hours > 0 || Mins > 0) {
                                                        //     minutes = minutes + Hours * 60 + Mins;
                                                        // }

                                                        // d["minutes"] = minutes;
                                                        return d;
                                                    }),
                                                    // isSetKey:"data"
                                                })
                                            }}
                                        >
                                        </TimePicker>
                                    </Col>
                                    </>}
                                    {/* <Col sm={2}>
                                        <span className="labeltext">
                                            Min's
                                        </span>
                                        <Input
                                        disabled={true} 
                                        value={reminderContent.minutes}
                                        ></Input>
                                    </Col> */}
                                    {/* </>} */}
                                    {/* <span className='pt-1 pl-4'>Minutes : {reminderContent.minutes}</span> */}
                                </Row>
                                <Row className="Input-Group mb-3">
                                    <Col>
                                        <Checkbox
                                            checked={reminderContent.IsRecurring == 1}
                                            onChange={val => {
                                                onChangeField({
                                                    value: val.target.checked ? 1 : 0,
                                                    field: "IsRecurring",
                                                    data: { ...reminderContent },
                                                    setDataFunction: (d) => setReminderContent(d),
                                                    // isSetKey:"data"
                                                })
                                            }}
                                        >Recurring</Checkbox>
                                    </Col>
                                </Row>
                                {reminderContent.IsRecurring == 1 && <Row className="Input-Group mb-3">
                                    <Col>
                                        <GlobalRecurring
                                            repeatObj={reminderContent.Recursion}
                                            setRepeatObj={data => {
                                                onChangeField({
                                                    value: data,
                                                    field: "Recursion",
                                                    data: { ...reminderContent },
                                                    setDataFunction: (d) => setReminderContent(d),
                                                    // isSetKey:"data"
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>}
                                <Row className="Input-Group  mb-3">
                                    <Col>
                                        <span className="labeltext">
                                            Description
                                        </span>
                                        <TextArea
                                            // disabled={bluePrintData?.lock == "true"}
                                            value={reminderContent?.Description}
                                            style={{
                                                padding: "5px 13px",
                                                "min-height": "5rem",
                                                "max-height": "5rem",
                                            }}
                                            onChange={(e) => {
                                                e.currentTarget.value = (e.currentTarget.value)?.trimStart();
                                                onChangeField({
                                                    value: e.currentTarget.value,
                                                    field: "Description",
                                                    data: { ...reminderContent },
                                                    setDataFunction: (d) => setReminderContent(d),
                                                    // isSetKey: "data"
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </div>
                            <div className='Button-Group-Footer'>
                                <Row className='Button-Group-Class'>
                                    <Col>
                                        <span style={{ color: "red" }}>{error?.length > 0 && "Please fill the required fields"}</span>
                                    </Col>
                                    <Col className='Button-Group-Class'>
                                        <Button style={{ width: "auto", padding: "7px" }}
                                            onClick={() => { setReminderContent(defaultReminder); }}
                                        >Clear</Button>
                                        <Button
                                            // disabled={error?.length>0}
                                            style={{ width: "auto", padding: "7px" }} type='primary'
                                            onClick={onReminderSave}
                                        >
                                            {reminderContent.ROWID ? "Update" : "Save"}
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Tabs.TabPane>
                </Tabs>
            </div>}
            placement="bottomLeft"
            trigger={"click"}
        >
            <Badge 
            // className='mr-3' 
            count={reminders?.length}>
                <Button
                    //   disabled={bluePrintData?.lock == "true"}
                    className="mr-1"
                    icon={
                        <img style={{ width: "15px" }} src={ReminderSvg}></img>
                    }
                ></Button>
            </Badge>
        </Popover>
    )
}
